module.exports = __webpack_public_path__ + "media/images/icons/outlined/slack-33a6eda9b02ffac7f25919e9c81763dd.svg";